import { GridColDef } from "esseal-data-table";
import { titleize } from "inflection";
import { Chip } from "@mui/material";
import { KickOffTemplate } from "@/graphql/generated/graphql";

const kickOffTemplatesColumns: GridColDef<KickOffTemplate>[] = [
  {
    field: "title",
    headerName: "Title",
    width: 500,
  },
  {
    field: "initiator",
    headerName: "Created by",
    width: 500,
    valueGetter: (row) => row.user?.firstName || "Unknown",
    renderCell: (data) => <Chip label={titleize(
      data.row.user ? `${data.row.user?.firstName} ${data.row.user?.lastName}` : "Unknown"
    )} />,
  },
];

export default kickOffTemplatesColumns;
